import { Link } from "react-router-dom";

import eyeIcon from "../../../assets/icons/eyeicon.svg";
import { unixToPersianDay } from "../../../utils/utils";

const TicketCard = ({ rowData }) => {
  return (
    <div className="bg-primary-10 py-2 px-4 rounded-[16px] flex flex-col gap-1  items-center shadow-lg border  ">
      <div className="flex justify-between items-center w-full">
        <div className=" flex-center items-top gap-1  text-dark  ">
          <img width={20} height={20} src={"/images/chaticon.svg "} alt="*" />
          <p className="max-w-[200px] truncate text-[16px]  font-semibold">{rowData.ticket.title}</p>
        </div>
        <Link title="جزئیات" to={`/ticketChat/${rowData.ticket.id}`}>
          <img src={eyeIcon} alt="editIcon" className="white-img " />
        </Link>
      </div>

      <div className="mt-2  flex flex-col gap-1 items-center w-full">
        <div className="flex flex-col text-dark gap-1  w-full rounded-[16px] text-title-sm-regular">
          <div className="flex justify-between items-center gap-2 w-full">
            <label className="text-[12px]" htmlFor="">
              تاریخ:
            </label>

            {unixToPersianDay(rowData?.ticket?.creation_time) ?? "-"}
          </div>

          <div className="flex justify-between items-center gap-2 w-full">
            <label className="text-[12px]" htmlFor="">
              دپارتمان:
            </label>
            {rowData.category.title}
          </div>
          <div className="flex justify-between items-center gap-2 w-full">
            <label className="text-[12px]" htmlFor="">
              وضعیت پیام
            </label>
            {rowData.ticket.state === "open" ? (
              <div className="bg-success-20 py-1 px-5 rounded-v-xs text-success-100 text-title-xs-regular">
                در جریان
              </div>
            ) : (
              <div className="bg-error-30 py-1 px-4 rounded-v-xs text-error-90">بسته‌شده</div>
            )}
          </div>
          <div className="flex justify-between items-center gap-2 w-full">
            <label className="text-[12px]" htmlFor="">
              وضعیت پاسخ پشتیبان
            </label>
            {!rowData.waiting_for_admin_response ? (
              <div className="bg-[#CED3D9] text-secondary-100 py-1 px-5 text-title-xs-regular rounded-v-xs">
                پاسخ داده شده
              </div>
            ) : (
              <div className="bg-warning-20 text-warning-100 py-1 px-5 text-title-xs-regular rounded-v-xs">
                منتظر پاسخ
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketCard;
